<template>
  <SysInputFormatadorDeValor
    v-model="VALOR"
    :max-digitos="configuracoes.CASAS_DECIMAIS_CARRINHO"
    remover-valor-irrelevante
    centralizar
    class="input-regular font-resp w-100"
    @focus="$event.target.select()"
    @keydown.enter="$emit('add-produto-carrinho', {})"
  />
</template>

<script>
import SysInputFormatadorDeValor from "@/components/utils/InputFormatadorDeValor.vue";
import SysInputFormatadorValor from "@/components/utils/InputFormatadorDeValor.vue";
import {mapGetters} from "vuex";

export default {
  name: "PrecoCusto",
  components: {SysInputFormatadorValor, SysInputFormatadorDeValor},
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: Number
  },
  computed: {
    VALOR: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      }
    },
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
    }),
  }
}
</script>

<style scoped>

</style>
